(function () {
  function initWhyUs(section) {
    if (!section || section.dataset.cleenyWhyUsReady === 'true') return;

    section.dataset.cleenyWhyUsReady = 'true';

    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      section.classList.add('is-visible');
      return;
    }

    if (!('IntersectionObserver' in window)) {
      section.classList.add('is-visible');
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.12
    });

    observer.observe(section);
  }

  function initAll(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-cleeny-why-us]').forEach(initWhyUs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();